// ─── Order status ────────────────────────────────────────────────────────────
// Frontend mirror of the backend OrderStatus enum (orders/order.entity.ts).
// The two apps don't share code, so this must be kept in sync with the backend.
export const OrderStatus = Object.freeze({
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  PROCESSING: 'processing',
  SHIPPED: 'shipped',
  DISPATCHED: 'dispatched',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
});

// ─── Delivery type ───────────────────────────────────────────────────────────
// Frontend mirror of the backend DeliveryType enum (orders/order.entity.ts).
// The two apps don't share code, so this must be kept in sync with the backend.
export const DeliveryType = Object.freeze({
  ON_DEMAND: 'on_demand',
  SCHEDULED: 'scheduled',
});

// ─── Admin notification messages ─────────────────────────────────────────────
export const ADMIN_NOTIFICATIONS = {
  NEW_ORDER_TITLE: 'New order received',
  NEW_ORDER_BODY_DEFAULT: 'A new order was placed.',
  NEW_ORDER_BODY_WITH_NUMBER: (orderNumber) => `Order ${orderNumber}`,
};

// ─── Date Formatting Options & Helpers ────────────────────────────────────────
export const IST_DATE_TIME_FORMAT_OPTIONS = Object.freeze({
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
  timeZone: 'Asia/Kolkata',
});

export const formatIstDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleString('en-IN', IST_DATE_TIME_FORMAT_OPTIONS);
};

